export default __webpack_public_path__ + "static/media/story3.432f973c.jpg";